// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__31Nf5","title":"InfoRow_title__3DzKc"};